module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_02@3x-e5b7588a137a099d9cd33e117b3092d4.webp";